import "./Vinyl.css";

const UMFANG = 842; // 2 * PI * 134 (Radius des Rings im 300er-Raster)

/** Ab wann der Ring von Gruen nach Rot wandert und wann er ganz rot ist (Sekunden). */
export function rotBereich(dauer) {
  const start = Math.min(10, dauer / 2);
  return { start, ende: Math.min(3, start / 2) };
}

/** Rot-Anteil 0..100 bei s verbleibenden Sekunden. */
export function rotAnteil(s, dauer) {
  const { start, ende } = rotBereich(dauer);
  if (s >= start) return 0;
  if (s <= ende) return 100;
  return Math.round(((start - s) / (start - ende)) * 100);
}

/**
 * Plattenspieler: Platte, Countdown-Ring, Tonarm.
 * playing: Platte dreht, Tonarm liegt auf. rest: verbleibender Anteil der
 * Zeit (0..1) oder null = kein Zeitlimit (Ring voll, ohne Ablauf).
 * dauer: Gesamtdauer in Sekunden. Mit ihr laeuft der Ring fliessend statt im
 * Sekundentakt (jede Sekunde linear dorthin, wo er eine Sekunde spaeter sein
 * muss), und die Farbe wandert stufenlos von Gruen ueber Gelb nach Rot
 * (data-rot in 5er-Stufen, Farben in Vinyl.css).
 * knapp: letzte Sekunden (ohne dauer: Ring springt auf Rot).
 * groesse: "gross" | "mittel" | "klein".
 * @category spiel
 */
export function Vinyl({ playing = false, rest = null, dauer = null, knapp = false, groesse = "gross" }) {
  const anteil = rest === null || rest === undefined ? 1 : Math.min(1, Math.max(0, rest));
  const klassen = ["plattenspieler", groesse, playing && "laeuft", knapp && "knapp"].filter(Boolean).join(" ");
  const mitLimit = rest !== null && rest !== undefined;
  const verlauf = mitLimit && dauer > 0;
  // Sekundenwert, auf den der Ring gerade zulaeuft
  const fliesst = verlauf && playing;
  const zielSek = verlauf ? Math.max(0, anteil * dauer - (fliesst ? 1 : 0)) : null;
  const zielAnteil = verlauf ? zielSek / dauer : anteil;
  // Rot-Anteil in 5er-Stufen; die Farben dazu stehen in Vinyl.css. Der
  // 1-s-Uebergang (Klasse "fliesst") macht daraus einen stufenlosen Verlauf.
  const rotStufe = verlauf ? Math.round(rotAnteil(zielSek, dauer) / 5) * 5 : undefined;
  return (
    <div className={klassen} aria-hidden="true">
      <div className="deck">
        <svg className="deck-ring" viewBox="0 0 300 300">
          <circle className="spur" cx="150" cy="150" r="134" />
          <circle
            className={`rest${mitLimit ? "" : " ohne-limit"}${verlauf ? " verlauf" : ""}${fliesst ? " fliesst" : ""}`}
            data-rot={rotStufe}
            cx="150"
            cy="150"
            r="134"
            strokeDasharray={UMFANG}
            strokeDashoffset={UMFANG * (1 - zielAnteil)}
          />
        </svg>
        <div className="platte">
          <div className="platte-label" />
        </div>
        <div className="platte-glanz" />
        <div className="tonarm">
          <span className="gewicht" />
          <span className="lager" />
          <span className="stab" />
          <span className="kopfteil" />
        </div>
      </div>
    </div>
  );
}

export default Vinyl;
